import { Button, ButtonProps, TelescopeTheme } from "@hubble/telescope";
import { config } from "./config";
import { FAQ } from "./static_faqs/types";
import RaisoniButton from "~/components/rnr_partners_custom_components.tsx/raisoni/button";
import { Mode } from "~/types";

export const FONTS = {
  default: [
    "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Krona+One&display=swap",
  ],
  rnr: ["https://fonts.googleapis.com/css2?family=Sacramento&display=swap"],
};

type ClientIdConfig = {
  axisClientId: string;
  tdClientId: string;
  bajajClientId: string;
  godrejPropertiesClientId: string;
  moneycontrolClientId: string;
  kotakClientId: string;
  onePercentClientId: string;
  stooferClientId: string;
  raisoniClientId: string;
  momentsRnrClientId: string;
  redeemHubbleClientId: string;
  brenClientId: string;
  visitHealthRewardsClientId: string;
  buddydealsClientId: string;
  brandLookBookClientId: string;
  rocheClientId: string;
  nielsenClientId: string;
  eazyErpClientId: string;
  eazyErpCromptonClientId: string;
  grassberryClientId: string;
  sunriseClientId: string;
  excellentPublicityClientId: string;
  rpTechClientId: string;
  oneAssistClientId: string;
  axisMaxLifeClientId: string;
  zoffersClientId: string;
  visaInEnClientId: string;
  almashinesClientId: string;
  shftxClientId: string;
  inentertainmentClientId: string;
  larsenToubroClientId: string;
  makeAndGrowthClientId: string;
  vyaparServicesClientId: string;
  mavenwitClientId: string;
  indriyaClientId: string;
  iciciIndriyaClientId: string;
  engageloyaltyClientId: string;
  smcClientId: string;
  drreddysClientId: string;
  hclTechClientId: string;
  gobabytravelClientId: string;
  rewardcartClientId: string;
  lawyaarClientId: string;
  mastercardIndriyaClientId: string;
  birlaOpusClientId: string;
  eshopEdgeClientId: string;
  swackitClientId: string;
  larsenToubroRealtyClientId: string;
  nayaraClientId: string;
  teamngageClientId: string;
  onecardClientId: string;
};

const CLIENT_ID_CONFIGS: Record<string, ClientIdConfig> = {
  prod: {
    axisClientId: "axisbank-llE1XBk0",
    raisoniClientId: "raisoni-A8Aa6FsT",
    tdClientId: "tata-digital-HmS62avt",
    bajajClientId: "bajajfinserv-CyyetFBG",
    godrejPropertiesClientId: "godrej-properties-rnr-FsDd6dSt",
    moneycontrolClientId: "moneycontrol-2lABGigG",
    momentsRnrClientId: "demo-hubble-c5m2Dvjd",
    redeemHubbleClientId: "redeem-hubble-wUk8BaJg",
    visitHealthRewardsClientId: "visit-health-rewards-Vj47UiA1",
    kotakClientId: "kotak-3GwSL6LLgP4Y",
    onePercentClientId: "one-percent-v2-0MAtl8AH",
    stooferClientId: "stoofers-1F9eGgKR",
    brenClientId: "bren-GVY69LmI",
    buddydealsClientId: "buddydeals-enR9L4ya",
    nielsenClientId: "nielseniq-76CHcQcM",
    eazyErpClientId: "eazyerp-crompton-ozvoGkRK",
    eazyErpCromptonClientId: "eazyerp-crompton-ozvoGkRK",
    brandLookBookClientId: "brand-look-book-JgMDEqwz",
    rocheClientId: "roche-fOcUfh3F",
    grassberryClientId: "grassberry-RPAwbRZv",
    sunriseClientId: "sunrise-3jiS3xK4",
    excellentPublicityClientId: "excellent-publicity-iOpO9ETL",
    rpTechClientId: "rptech-rnr-pyiUwctU",
    oneAssistClientId: "oneassist-rnr-Kda6vcbK",
    axisMaxLifeClientId: "axis-max-life-to-be-added",
    zoffersClientId: "zoffers-to-be-added",
    visaInEnClientId: "visa-inen-mbTBuqJN",
    almashinesClientId: "almashines-to-be-added",
    shftxClientId: "shftx-4hGYoGgE",
    inentertainmentClientId: "inentertainment-rnr-nR0Y9oKW",
    larsenToubroClientId: "larsen-toubro-to-be-added",
    makeAndGrowthClientId: "makeandgrowth-to-be-added",
    vyaparServicesClientId: "vyapar-services-to-be-added",
    mavenwitClientId: "mavenwit-rnr-mUU45XrU",
    indriyaClientId: "axisbank-indriya-rnr-zgD76P60",
    iciciIndriyaClientId: "icici-mastercard-indriya-rnr-Y8OQoIqz",
    engageloyaltyClientId: "engageloyalty-to-be-added",
    smcClientId: "smc-to-be-added",
    drreddysClientId: "drreddys-to-be-added",
    hclTechClientId: "hcltech-to-be-added",
    gobabytravelClientId: "gobabytravel-rnr-nKBIf9qh",
    rewardcartClientId: "rewardcart-rnr-qzbbr0pv",
    lawyaarClientId: "lawyaar-rnr-7c02so00",
    mastercardIndriyaClientId: "mastercard-indriya-rnr-xGmLMsuw",
    birlaOpusClientId: "birla-opus-rnr-r1zentlb",
    eshopEdgeClientId: "eshopedge-to-be-added",
    swackitClientId: "swackit-to-be-added",
    larsenToubroRealtyClientId: "larsen-toubro-realty-to-be-added",
    nayaraClientId: "nayara-energy-rnr-y4uyvcto",
    teamngageClientId: " teamngage-to-be-added",
    onecardClientId: "onecard-rnr-Mb5HhycY",
  },
  nonProd: {
    axisClientId: "acme-code-3241c2c1",
    raisoniClientId: "raisoni-dev",
    tdClientId: "tata-digital-23gvn314",
    bajajClientId: "bajaj-code-Bp3sxUCw",
    godrejPropertiesClientId: "godrej-properties-rnr-LEj5WNL5",
    moneycontrolClientId: "moneycontrol-QH53rltu",
    momentsRnrClientId: "acme-3241c2c1",
    redeemHubbleClientId: "redeem-hubble-059mzyEK",
    visitHealthRewardsClientId: "visit-health-rewards-mkyspH1P",
    kotakClientId: "kotak-sdk",
    onePercentClientId: "one-percent-v2-Fmozeq0e",
    stooferClientId: "stoofers-oPExjdmx",
    brenClientId: "bren-I9Up5fKI",
    buddydealsClientId: "buddydeals-dL9Z7lL1",
    nielsenClientId: "nielsen-QEjZqzmO",
    eazyErpClientId: "eazyerp-AtxiyhVX",
    eazyErpCromptonClientId: "eazyerp-crompton-IEhYJ60L",
    brandLookBookClientId: "brand-look-book-dev-XbTiXPF7",
    rocheClientId: "roche-dev-uFMpMCCQ",
    grassberryClientId: "grassberry-dev-gRM06l3u",
    sunriseClientId: "sunrise-dev-be-added",
    excellentPublicityClientId: "excellent-publicity-dev-be-added",
    rpTechClientId: "rptech-rnr-dev-be-added",
    oneAssistClientId: "oneassist-dev-xQzg8MYD",
    axisMaxLifeClientId: "axismaxlife-dev-GJ9XSqtY",
    zoffersClientId: "zoffers-dev-9LQFDRYN",
    visaInEnClientId: "visa-inen-dev-w2VC5liw",
    almashinesClientId: "almashines-dev-YawhGQPB",
    shftxClientId: "shftx-dev-VSQWJs7S",
    inentertainmentClientId: "inentertainment-dev-0VTnlsmk",
    larsenToubroClientId: "larsen-toubro-dev-NHkeYoOm",
    makeAndGrowthClientId: "make-and-growth-rnr-dev-wVtLcmqj",
    vyaparServicesClientId: "vyapar-services-dev-S3ozd9PG",
    mavenwitClientId: "mavenwit-dev-0mUM6wG8",
    indriyaClientId: "indriya-dev-uZyj062N",
    iciciIndriyaClientId: "icici-mastercard-rnr-dev-Jnm83Ndq",
    engageloyaltyClientId: "engageloyalty-dev-1qY07QTp",
    smcClientId: "smc-dev-s5upOQoa",
    drreddysClientId: "drreddys-dev-wFexuBsg",
    hclTechClientId: "hcltech-dev-7IXaUYXD",
    gobabytravelClientId: "gobabytravel-rnr-dev-Slq50qPm",
    rewardcartClientId: "rewardcart-rnr-dev-G2rf0q9f",
    lawyaarClientId: "lawyaar-rnr-dev-dNfBWO3s",
    mastercardIndriyaClientId: "mastercard-indriya-rnr-dev-80zw4KHq",
    birlaOpusClientId: "birla-opus-rnr-dev-jbfuzSb3",
    eshopEdgeClientId: "eshopedge-rnr-dev-wHCwvDpq",
    swackitClientId: "swackit-rnr-dev-uUAqh3Yj",
    larsenToubroRealtyClientId: "larsen-toubro-realty-rnr-dev-1nKYPkEi",
    nayaraClientId: "nayara-energy-rnr-dev-mRNG7qwr",
    teamngageClientId: "teamngage-rnr-dev-l1MWHctf",
    onecardClientId: "onecard-rnr-dev-3nRkmdDG",
  },
};

export const clientIdConfig =
  config.env === "Prod" ? CLIENT_ID_CONFIGS.prod : CLIENT_ID_CONFIGS.nonProd;

const iframeEmbedHost = {
  prod: {
    visitHealthRewardsClientId: {
      host: "visit-health-rewards.hubble-rewards.com",
      clientId: clientIdConfig.visitHealthRewardsClientId,
      clientSecret:
        "lq3ExGzyyhB5aP6YAJ1eXSHlsGwAMOVsstsquafU7lCHDVuP8qJvMzzJXxWNqLJy",
    },
  },
  nonProd: {
    visitHealthRewardsClientId: {
      host: "visit-health-rewards.dev.hubble-rewards.com",
      clientId: clientIdConfig.visitHealthRewardsClientId,
      clientSecret:
        "uVh2zkcGSWr0VZKZefrHYnTCuj8B89x2XUAO5HjPWIWhvlB96PAp2AvylDC2uAPc",
    },
  },
};

export const iframeEmbedHostConfig =
  config.env === "Prod" ? iframeEmbedHost.prod : iframeEmbedHost.nonProd;

export function accomodateHigherBrandsPerRowOnHomeForCodeBasedPortal(
  clientId?: string
): boolean {
  // true only for td client
  return clientId === clientIdConfig.tdClientId;
}

export function isHostOnlyForIframeEmbed(host: string) {
  return (
    host === "visit-health-rewards.dev.hubble-rewards.com" ||
    host === "visit-health-rewards.hubble-rewards.com"
  );
}

export function getVoucherDescBrandingReplacement(clientId: string): string {
  /*
  Eg.
  Default - Access discounts on groceries and household essentials at Bigbasket with a discounted gift card from Hubble.

  For Raisoni
  Access discounts on groceries and household essentials at Bigbasket with a discounted gift card from Raisoni Privilege.
  */
  if (clientId === clientIdConfig.raisoniClientId) {
    return "Raisoni Privilege";
  } else if (clientId === clientIdConfig.buddydealsClientId) {
    return "Buddy Deal";
  } else if (clientId === clientIdConfig.nielsenClientId) {
    return "NielsenIQ";
  }

  return "Hubble";
}

export function shouldDisableLogout(clientId?: string): boolean {
  // Disable logout for Visit Health Rewards client (embedded iframe scenarios)
  return (
    clientId === clientIdConfig.visitHealthRewardsClientId ||
    clientId === clientIdConfig.grassberryClientId
  );
}

export const useMomentsV3 = (clientId?: string) => {
  if (clientId === clientIdConfig.axisClientId) {
    return false;
  }
  if (clientId === clientIdConfig.tdClientId) {
    return false;
  }
  return true;
};

export const enableSingleBrandHomepage = (clientId?: string) => {
  // Enable single brand homepage for specific clients
  // This will show a brand page-like experience on the homepage when only 1 brand is available
  // if (!clientId) {
  //   return false;
  // }

  // Add client IDs here to enable the feature
  // Example: return clientId === clientIdConfig.someClientId;

  // Temporarily enabled for all clients for testing
  return true;
};

export function getHomeRnrHeaderSubtitle(clientId: string): {
  line1: string;
  line2?: string;
} {
  if (clientId === clientIdConfig.grassberryClientId) {
    return { line1: "Shop on 400+ brands" };
  }
  return { line1: "Shop on 400+ brands with", line2: "your coins" };
}

// properties which frequently change for each client are stored here
// any functionality which is specific to a client can be kept in code behind client id check

export type MomentsV3PartnerConfig = {
  headerBgColor?: string;
  brandColor?: string;
  gradientColor?: string;
  showGradient: boolean;
  loginPage?: {
    backgroundColor?: string;
    backgroundImageUrl?: string;
    smallTitle?: string;
    largeTitle?: string;
  };
  homepage?: {
    smallTitle?: string;
    largeTitle?: string;
  };
  theme: TelescopeTheme;
  showCoins: boolean;
  allowCodeApplication: boolean;
  showHubbleBranding: boolean;
  logoUrl: string;
  pageTitle?: string;
  pageIcon?: string;
  fAQsInHeader?: FAQ[];
  termsAndConditionsUrl?: string;

  // default will be true
  showWhatsappDeliveryMessage: boolean;
  showUserDataCollectionModal: boolean;
  showContactSupport?: boolean;
  showEmailDeliveryMessage?: boolean;
};

export const getMomentsV3PartnerConfig = (
  clientId: string
): MomentsV3PartnerConfig => {
  return momentsV3PartnerConfig[clientId] ?? defaultMomentsV3PartnerConfig;
};

export const BRANDS_COUNT = 450;

const momentsV3PartnerConfig: Record<string, MomentsV3PartnerConfig | null> = {
  // for axis bank and tata digital, only theme property is used
  [clientIdConfig.axisClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    headerBgColor: "#000000",
    brandColor: "#000000",
    logoUrl: "",
    showWhatsappDeliveryMessage: false,
    showUserDataCollectionModal: false,
  },
  [clientIdConfig.tdClientId]: {
    theme: "telescope-dark-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    headerBgColor: "#000000",
    brandColor: "#000000",
    logoUrl: "",
    showWhatsappDeliveryMessage: false,
    showUserDataCollectionModal: false,
  },
  [clientIdConfig.momentsRnrClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: true,
    showHubbleBranding: true,
    logoUrl: "https://assets.myhubble.money/web-assets/hubble_logo.png",
    loginPage: {
      smallTitle: "Welcome to rewards portal 👋",
      largeTitle: `Redeem coins to shop on ${BRANDS_COUNT}+ brands`,
    },
    showUserDataCollectionModal: true,
    termsAndConditionsUrl: "https://www.myhubble.money/terms-and-conditions",
    showWhatsappDeliveryMessage: true,
    brandColor: "#171717",
  },
  [clientIdConfig.rocheClientId]: {
    theme: "telescope-dark-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    headerBgColor: "#0C41CD",
    brandColor: "#0C41CD",
    loginPage: {
      smallTitle: "Welcome",
      largeTitle: "Happy Festivities",
    },
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/roche_logo_2.png",
    showWhatsappDeliveryMessage: false,
    showUserDataCollectionModal: false,
  },
  [clientIdConfig.bajajClientId]: {
    theme: "telescope-dark-theme",
    headerBgColor: "#0071BB",
    brandColor: "#0071BB",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    loginPage: {
      smallTitle: "👋 Welcome",
      largeTitle: "We’re grateful to have you as a customer",
    },
    homepage: {
      smallTitle: "Welcome",
      largeTitle: "Shop on your favourite brands with coins",
    },
    showHubbleBranding: true,
    logoUrl: "https://assets.myhubble.money/web-assets/bajaj-finserv-3x.png",
    showWhatsappDeliveryMessage: true,
    showUserDataCollectionModal: true,
  },
  [clientIdConfig.raisoniClientId]: {
    theme: "telescope-light-theme",
    showGradient: false,
    gradientColor: "#ff5100",

    showCoins: false,
    allowCodeApplication: false,
    loginPage: {},
    homepage: {
      smallTitle: "Welcome",
      largeTitle: `Enjoy exclusive Raisonian discount on ${BRANDS_COUNT}+ brands`,
    },
    showHubbleBranding: true,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/raisoni-logo.webp",
    showWhatsappDeliveryMessage: false,
    showUserDataCollectionModal: true,
  },
  [clientIdConfig.moneycontrolClientId]: {
    theme: "telescope-dark-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/moneycontrol-logo.webp",
    loginPage: {
      smallTitle: "👋 Welcome to Moneycontrol Privileges",
    },
    showHubbleBranding: true,
    headerBgColor: "#1A1A22",
    homepage: {
      smallTitle: "Welcome",
      largeTitle: `Redeem your Moneycontrol coins on your favourite brands!`,
    },
    showWhatsappDeliveryMessage: true,
    showUserDataCollectionModal: true,
  },
  [clientIdConfig.godrejPropertiesClientId]: {
    theme: "telescope-dark-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    headerBgColor: "#3555FF",
    brandColor: "#3555FF",
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/godrej_logo.webp",
    // "https://assets.myhubble.money/web-assets/corp-gifting/godrej_logo_v2.png",
    loginPage: {
      smallTitle: "Congratulations on your new home at Godrej Properties! 🏡",
      largeTitle:
        "Wishing you endless joy and beautiful memories in your new space.",
    },
    homepage: {
      largeTitle: "Shop on your favourite brands with coins",
    },
    showWhatsappDeliveryMessage: true,
    showUserDataCollectionModal: true,
  },
  [clientIdConfig.buddydealsClientId]: {
    theme: "telescope-light-theme",
    showGradient: false,
    brandColor: "#000000",

    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: false,
    logoUrl: "https://assets.myhubble.money/web-assets/buddy_logo_black_3.svg",
    showWhatsappDeliveryMessage: false,
    showUserDataCollectionModal: false,
    pageTitle: "BuddyDeal - India's First Military Discount Platform",
    pageIcon: "https://assets.myhubble.money/web-assets/buddy_favicon.svg",
  },
  [clientIdConfig.nielsenClientId]: {
    theme: "telescope-light-theme",
    showGradient: false,
    brandColor: "#2E6DF6",
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    logoUrl:
      "https://assets.myhubble.money/web-assets/NIQ-logo-bright-blue.svg",
    showWhatsappDeliveryMessage: false,
    showUserDataCollectionModal: false,
  },
  [clientIdConfig.sunriseClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: true,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    brandColor: "#691A24",
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/sunrise-logo.webp",
    showWhatsappDeliveryMessage: true,
  },
  [clientIdConfig.excellentPublicityClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: true,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    brandColor: "#C01625",
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/excellent-publicity-logo.webp",
    showWhatsappDeliveryMessage: true,
  },
  [clientIdConfig.visitHealthRewardsClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: true,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    brandColor: "#714FFF",
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/visithealth_logo.svg",
  },
  [clientIdConfig.redeemHubbleClientId]: {
    theme: "telescope-dark-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/hubble-dark-svg.svg",
  },
  [clientIdConfig.grassberryClientId]: {
    theme: "telescope-light-theme",
    showGradient: false,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: false,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    brandColor: "#0171DE",
    logoUrl:
      "https://assets.myhubble.money/web-assets/grassberry-moments-logo-v2.svg",
  },
  [clientIdConfig.brandLookBookClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    loginPage: {
      smallTitle: "Welcome to Turner & Townsend Reward Portal",
      largeTitle: "Celebrating the spirit of Diwali with you",
    },
    logoUrl:
      "https://assets.myhubble.money/web-assets/brand_look_book_logo.png",
  },
  [clientIdConfig.rpTechClientId]: {
    theme: "telescope-light-theme",
    loginPage: {
      smallTitle: "👋 Welcome to RP Tech Rewards Portal",
    },
    homepage: {
      smallTitle: "👋 Welcome to RP Tech Rewards Portal",
      largeTitle: "Claim your reward",
    },
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/rp_tech_logo_3.png",
    // "https://assets.myhubble.money/web-assets/corp-gifting/rp_tech_logo.png",
    showGradient: true,
    showCoins: true,
    brandColor: "#9F2A7E",
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
  },
  [clientIdConfig.oneAssistClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    brandColor: "#0082EF",
    loginPage: {
      smallTitle: "Welcome to One Assist Rewards Portal 👋",
      largeTitle: "Enjoy exclusive discounts on 450+ brands",
    },
    homepage: {
      smallTitle: "Welcome to One Assist Rewards Portal 👋",
      largeTitle: "Enjoy discounts on 450+ brands",
    },
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/one_assist_logo.png",
  },
  [clientIdConfig.axisMaxLifeClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/axis_max_life_logo_2.png",
    brandColor: "#97134d",
    loginPage: {
      smallTitle: "Welcome to Axis Max Life insurance Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
    homepage: {
      smallTitle: "Welcome to Axis Max Life insurance Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.zoffersClientId]: {
    theme: "telescope-dark-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/zoffers_logo_dark_cropped.png",
    brandColor: "#00a63d",
    loginPage: {
      smallTitle: "Welcome to Zoffers Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
      backgroundImageUrl:
        "https://assets.myhubble.money/web-assets/corp-gifting/zoffers_login_bg.webp",
    },
    homepage: {
      smallTitle: "Welcome to Zoffers Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.visaInEnClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/ine_logo.jpeg",
    brandColor: "#00a63d",
    loginPage: {
      smallTitle: "Welcome",
      largeTitle: `We’re grateful to have you as a customer`,
    },
    homepage: {
      smallTitle: "Welcome",
      largeTitle: `We’re grateful to have you as a customer`,
    },
  },
  [clientIdConfig.almashinesClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/almashines_logo.svg",
    brandColor: "#0f6cbd",
    loginPage: {
      smallTitle: "Welcome to Almashines Rewards Portal",
      largeTitle: `Enjoy exclusive discount on ${BRANDS_COUNT}+ brands`,
    },
    homepage: {
      smallTitle: "Welcome to Almashines Rewards Portal",
      largeTitle: `Enjoy exclusive discount on ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.shftxClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/shftx_logo.png",
    brandColor: "#19904A",
    loginPage: {
      largeTitle: `Claim Your Rewards`,
    },
    homepage: {
      largeTitle: `Claim Your Rewards`,
    },
  },
  [clientIdConfig.inentertainmentClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/ine_logo.jpeg",
    brandColor: "#00a63d",
  },
  [clientIdConfig.larsenToubroClientId]: {
    theme: "telescope-dark-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    headerBgColor: "#ffc71b",
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/lnt_logo.png",
    brandColor: "#024d87",
    loginPage: {
      smallTitle: "Welcome to L&T Realty Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
    homepage: {
      smallTitle: "Welcome to L&T Realty Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.makeAndGrowthClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/make_and_growth_logo_2.jpg",
    brandColor: "#0c553c",
    loginPage: {
      smallTitle: `Welcome to Make and Growth Rewards Portal`,
      largeTitle: "We’re grateful to have you as a customer",
    },
    homepage: {
      smallTitle: `Welcome to Make and Growth Rewards Portal`,
      largeTitle: "We’re grateful to have you as a customer",
    },
  },
  [clientIdConfig.vyaparServicesClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/my_brand_making_logo.webp",
    brandColor: "#008ed2",
    loginPage: {
      smallTitle: "Welcome to My Brand Making Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
    homepage: {
      smallTitle: "Welcome to My Brand Making Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.mavenwitClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/mavenwit.png",
    brandColor: "#CE1411",
    headerBgColor: "#000000",
    gradientColor: "#cc0000",
    loginPage: {
      smallTitle: "Welcome to Mavenwit Rewards",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
    homepage: {
      smallTitle: "Welcome to Mavenwit Rewards",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.indriyaClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    logoUrl: "",
    brandColor: "#97144d",
  },
  [clientIdConfig.iciciIndriyaClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    gradientColor: "#EF7020",
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    logoUrl: "",
    brandColor: "#EF7020",
  },
  [clientIdConfig.mastercardIndriyaClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    gradientColor: "#c34100",
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    logoUrl:
      "https://www.mastercard.co.in/content/dam/public/mastercardcom/in/en/logos/mc-logo-52.svg",
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    brandColor: "#c34100",
    headerBgColor: "#141413",
    loginPage: {
      // backgroundColor: "#e3dfd7",
      smallTitle: "Welcome to Mastercard Rewards Portal",
      largeTitle: "We're grateful to have you as a customer",
    },
    termsAndConditionsUrl:
      "https://www.mastercard.co.in/en-in/vision/who-we-are/terms-of-use.html",
  },
  [clientIdConfig.engageloyaltyClientId]: {
    theme: "telescope-light-theme",
    showGradient: false,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/engage_loyalty_logo.webp",
    brandColor: "#083443",
    loginPage: {
      smallTitle: "Global Loyalty Platform",
      largeTitle: "Power your loyalty program with real-time rewards",
      backgroundImageUrl:
        "https://assets.myhubble.money/web-assets/corp-gifting/login_bg_engage.png",
    },
  },
  [clientIdConfig.smcClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/smc_logov1.webp",
    brandColor: "#1D3A7C",
  },
  [clientIdConfig.drreddysClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/drreddys_logo.webp",
    brandColor: "#532F91",
  },
  [clientIdConfig.hclTechClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/hcl_logo.webp",
    brandColor: "#0E5DEC",
    homepage: {
      largeTitle: `Enjoy deals from ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.gobabytravelClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/gobaby_travel_logo.webp",
    brandColor: "#29B1F9",
    loginPage: {
      smallTitle:
        "GoBaby Rewards is an exclusive privilege program designed for travelers — where every journey unlocks curated lifestyle benefits across dining, shopping, and experiences",
      largeTitle: "Unlock Privileges. Travel Better.",
    },
  },
  [clientIdConfig.rewardcartClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/reward_cart.webp",
    brandColor: "#1E93D0",
    loginPage: {
      smallTitle: "Welcome to Rewards Portal 👋",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
    homepage: {
      smallTitle: "Welcome to Rewards Portal 👋",
      largeTitle: `Enjoy instant discount on ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.lawyaarClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/lawyaar_logo_v1.webp",
    brandColor: "#1701a2",
    loginPage: {
      smallTitle: "Welcome to Lawyaar's Rewards Portal 👋",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
    homepage: {
      smallTitle: "Welcome to Rewards Portal 👋",
      largeTitle: `Enjoy instant discount on ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.birlaOpusClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl:
      "https://assets.myhubble.money/web-assets/birlaopus_brand_logo.webp",
    brandColor: "#000000",
  },
  [clientIdConfig.eshopEdgeClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/eshopedge_logo.png",
    brandColor: "#0069B9",
  },
  [clientIdConfig.swackitClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/swackit_logo.png",
    brandColor: "#563A96",
    loginPage: {
      largeTitle: `Get Gift Cards from ${BRANDS_COUNT}+ brands`,
    },
    homepage: {
      largeTitle: `Get Gift Cards from ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.larsenToubroRealtyClientId]: {
    theme: "telescope-dark-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    headerBgColor: "#ffc71b",
    logoUrl:
      "https://assets.myhubble.money/web-assets/corp-gifting/lnt_logo.png",
    brandColor: "#024d87",
    loginPage: {
      smallTitle: "Welcome to L&T Realty Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
    homepage: {
      smallTitle: "Welcome to L&T Realty Rewards Portal",
      largeTitle: `Enjoy exclusive discounts on ${BRANDS_COUNT}+ brands`,
    },
  },
  [clientIdConfig.nayaraClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: true,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/nayara_logov2.webp",
    brandColor: "#14447E",
  },
  [clientIdConfig.teamngageClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: false,
    showWhatsappDeliveryMessage: false,
    logoUrl: "https://assets.myhubble.money/web-assets/teamngage_logo.png",
    brandColor: "#0F5C76",
    loginPage: {
      largeTitle: `You work hard, it’s time for some rewards.`,
    },
    homepage: {
      largeTitle: `You work hard, it’s time for some rewards.`,
    },
  },
  [clientIdConfig.onecardClientId]: {
    theme: "telescope-light-theme",
    showGradient: true,
    showCoins: false,
    loginPage: {
      smallTitle: "Your discounted Gift Cards are just a click away!",
      largeTitle: "Special Offer for OneCard Customers",
    },
    homepage: {
      largeTitle: "Claim your Discount GiftCard",
    },
    allowCodeApplication: false,
    showHubbleBranding: true,
    showUserDataCollectionModal: true,
    showWhatsappDeliveryMessage: false,
    showContactSupport: false,
    showEmailDeliveryMessage: true,
    logoUrl: "https://assets.myhubble.money/web-assets/hubble_logo.png",
    brandColor: "#000000",
  },
};

const defaultMomentsV3PartnerConfig: MomentsV3PartnerConfig = {
  showGradient: true,
  loginPage: {},
  showHubbleBranding: true,
  theme: "telescope-light-theme",
  showCoins: true,
  allowCodeApplication: false,
  showWhatsappDeliveryMessage: false,
  showUserDataCollectionModal: false,
  logoUrl: "https://assets.myhubble.money/web-assets/hubble_logo.png",
};

export function getBrandColor(clientId: string): string | undefined {
  return getMomentsV3PartnerConfig(clientId).brandColor;
}

/**
 * This function is used to override the default telescope components for a specific client and mode
 * @param clientId - The client id
 * @param mode - The mode
 * @returns The overriden telescope components
 */
export function getOverridenTelescopeComponents(params: {
  clientId: string;
  mode: Mode;
}) {
  const { clientId, mode } = params;

  function getOverrideButtonProps(props: ButtonProps): ButtonProps {
    function getButtonStyle(): ButtonProps["style"] {
      if (mode === "rnr" && props.style !== "error") {
        // override button style only for rnr primary button
        return "brand";
      }
      return props.style;
    }

    if (props.variant == "primary") {
      // override button style only for rnr primary button
      return {
        ...props,
        style: getButtonStyle(),
      };
    }

    return props;
  }

  if (clientId === clientIdConfig.raisoniClientId) {
    return {
      Button: RaisoniButton,
    };
  }

  if (
    clientId === clientIdConfig.redeemHubbleClientId ||
    clientId === clientIdConfig.brandLookBookClientId
  ) {
    // no need to override button style for redeem Hubble client
    return {};
  }
  return {
    Button: (props: ButtonProps) => (
      <Button {...getOverrideButtonProps(props)} />
    ),
  };
}
